import React from "react";
import { SampleBadge } from "./SampleBadge";

export const PageHeader = ({ title, subtitle, actions, showSampleBadge = true, testId }) => {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between" data-testid={testId}>
      <div className="min-w-0">
        <div className="flex items-center gap-2.5">
          <h1 className="font-display text-2xl font-bold tracking-tight text-emerald-950 sm:text-3xl">
            {title}
          </h1>
          {showSampleBadge && <SampleBadge />}
        </div>
        {subtitle && (
          <p className="mt-1.5 text-sm text-emerald-900/60">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
};
